module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/icon-chat.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/icon-chat.png
// module id = 1211
// module chunks = 0